import SecureRequest from "../utils/securerequest";

export async function checkFeatureAccess(userId, featureName) {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  const url = `/v2/feature-access/check/${userId}?featureName=${encodeURIComponent(featureName)}`;

  try {
    const { data } = await Request.get(url);
    const { hasAccess } = data;
    return hasAccess;
  } catch (error) {
    console.error("Error in checkFeatureAccess:", error);
    throw error;
  }
}

/**
 * Returns the names of every feature flag the given user has access to
 * whose name starts with `prefix`. The server only allow-lists certain prefixes
 * (e.g. `exp_iso_`).
 *
 * @param {string} prefix - Flag-name prefix to filter by.
 * @param {string|number} userId - The user whose flags to look up.
 * @returns {Promise<string[]>}
 * @throws On network/server errors (lets react-query handle retries).
 */
export async function listFeatureFlagsByPrefix(prefix, userId) {
  if (!prefix || !userId) return [];

  const sr = new SecureRequest();
  const Request = sr.getRequest();
  const params = new URLSearchParams({ prefix, userId: String(userId) });
  const url = `/v2/feature-access/list-by-prefix?${params.toString()}`;

  const { data } = await Request.get(url);
  return Array.isArray(data?.flags) ? data.flags : [];
}
